import React from "react";
import { useTranslation } from "react-i18next";
import BanquetNavbar from "../components/BanquetNavbar";

const CeremonyPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex-1 flex flex-col">
      <div className="flex-none">
        <BanquetNavbar />
      </div>
      <div className="flex-1 flex items-center justify-center py-4">
        <div className="w-full max-w-6xl px-4 my-auto">
          <div className="bg-white rounded-lg shadow-xl p-6">
            <h2 className="text-2xl font-bold text-beast-brown-800 mb-6 text-center">
              {t('sections.ceremony.title')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="aspect-video rounded-lg overflow-hidden">
                <img
                  src="/fantasy.jpg"
                  alt={t('sections.ceremony.title')}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col justify-center">
                                <h3 className="text-xl font-semibold text-beast-brown-800 mb-4">
                  Ceremonia Civil 
                </h3>
                <p className="text-sm text-beast-brown-700">
                  {t('sections.ceremony.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CeremonyPage;
